import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.projects');
import { workspaceDateTime } from "src/libs/portal/review/workspace-ui";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review-projects',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.projects/view.scss */
:host {
  --creation-canvas: #f5f6f2;
  --creation-surface: #ffffff;
  --creation-surface-muted: #f9faf7;
  --creation-ink: #242821;
  --creation-muted: #6f756c;
  --creation-subtle: #969c93;
  --creation-line: #dfe3db;
  --creation-line-strong: #ccd3c8;
  --creation-orange: #df5934;
  --creation-orange-dark: #bd4325;
  --creation-orange-soft: #fff1eb;
  --creation-olive: #667d3e;
  --creation-olive-soft: #eff4e8;
  --creation-green: #2e745d;
  --creation-green-soft: #eaf4f0;
  --creation-violet: #655781;
  --creation-violet-soft: #f0edf6;
  display: block;
  min-height: 100%;
  color: var(--creation-ink);
  font-family: Pretendard, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

button,
input {
  font: inherit;
}

button {
  border: 0;
}

.creation-page {
  min-height: 100%;
  overflow-x: hidden;
  background: var(--creation-canvas);
}

.creation-shell {
  width: min(100% - 48px, 1480px);
  margin-inline: auto;
}

.creation-header {
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid var(--creation-line);
}

.creation-heading {
  min-width: 0;
}

.creation-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.creation-eyebrow i {
  font-size: 12px;
}

.creation-heading h1 {
  margin: 10px 0 0;
}

.creation-heading > p:last-child {
  margin: 10px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.6;
}

.creation-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.creation-utility,
.creation-primary,
.row-action button,
.project-card > button,
.project-empty button,
.project-ledger__footer button,
.modal-cancel,
.modal-submit,
.project-created-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  cursor: pointer;
  transition: color 160ms ease, background-color 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.creation-utility {
  min-height: 40px;
  gap: 8px;
  padding: 0 13px;
  color: #5f675e;
  background: #fff;
  border: 1px solid var(--creation-line);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.creation-utility:hover {
  color: var(--creation-ink);
  background: var(--creation-surface-muted);
  border-color: var(--creation-line-strong);
}

.creation-primary {
  min-height: 46px;
  gap: 9px;
  margin-left: 8px;
  padding: 0 18px;
  color: #fff;
  background: var(--creation-orange);
  box-shadow: 0 8px 18px rgba(181, 65, 34, 0.14) !important;
}

.creation-primary:hover {
  background: var(--creation-orange-dark);
  transform: translateY(-1px);
}

.creation-primary i {
  font-size: 12px;
}

.creation-overview {
  display: grid;
  grid-template-columns: minmax(250px, 1.35fr) repeat(3, minmax(170px, 1fr));
  overflow: hidden;
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
  border-radius: 13px;
  box-shadow: 0 5px 18px rgba(45, 54, 43, 0.04);
}

.creation-overview > article {
  min-width: 0;
  min-height: 118px;
  padding: 22px 24px;
}

.creation-overview > article + article {
  border-left: 1px solid var(--creation-line);
}

.creation-overview__intro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #30352f;
}

.creation-overview__intro > span {
  color: #bfc7bb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.creation-overview__intro strong {
  margin-top: 7px;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.creation-overview__intro p {
  max-width: 340px;
  margin: 7px 0 0;
  color: #c9cec6;
  font-size: 12px;
  line-height: 1.55;
}

.creation-metric {
  display: flex;
  align-items: center;
  gap: 14px;
}

.creation-metric__icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 11px;
  font-size: 15px;
}

.creation-metric__icon.is-orange {
  color: #bd4a29;
  background: var(--creation-orange-soft);
}

.creation-metric__icon.is-violet {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.creation-metric__icon.is-green {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.creation-metric div {
  min-width: 0;
}

.creation-metric small,
.creation-metric strong,
.creation-metric p {
  display: block;
}

.creation-metric small {
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.creation-metric strong {
  margin-top: 3px;
  color: var(--creation-ink);
  font-size: 25px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.creation-metric p {
  margin: 7px 0 0;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.creation-path {
  display: grid;
  grid-template-columns: minmax(250px, 0.85fr) minmax(0, 2.5fr);
  align-items: stretch;
  overflow: hidden;
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
  border-radius: 13px;
  box-shadow: 0 5px 18px rgba(45, 54, 43, 0.035);
}

.creation-path__header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 22px 24px;
  background: var(--creation-surface-muted);
  border-right: 1px solid var(--creation-line);
}

.creation-path__header span,
.project-ledger__title span {
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.creation-path__header h2 {
  margin: 6px 0 0;
  color: var(--creation-ink);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.creation-path__header > p {
  margin: 8px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.creation-path__steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}

.creation-path__steps li {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-content: center;
  column-gap: 11px;
  min-width: 0;
  padding: 20px 17px;
}

.creation-path__steps li + li {
  border-left: 1px solid #ecefe9;
}

.creation-path__number {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #c5cac2;
  font-size: 12px;
  font-weight: 700;
}

.creation-path__steps li > i {
  display: grid;
  width: 34px;
  height: 34px;
  grid-row: 1/3;
  place-items: center;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 9px;
  font-size: 12px;
}

.creation-path__steps strong {
  align-self: end;
  color: #343a33;
  font-size: 12px;
  font-weight: 700;
}

.creation-path__steps p {
  align-self: start;
  margin: 4px 0 0;
  color: var(--creation-subtle);
  font-size: 12px;
  line-height: 1.45;
}

.project-ledger {
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
}

.project-ledger__title {
  display: grid;
  grid-template-columns: auto auto;
  align-items: end;
  gap: 0 10px;
}

.project-ledger__title > div {
  min-width: 0;
}

.project-ledger__title h2 {
  margin: 5px 0 0;
  color: var(--creation-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.project-ledger__title > strong {
  align-self: end;
  margin-bottom: 2px;
  padding: 4px 7px;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.project-ledger__title > p {
  grid-column: 1/-1;
  margin: 7px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
}

.project-search {
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line-strong);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.project-search:focus-within {
  border-color: #83976a;
}

.project-search > i {
  font-size: 12px;
}

.project-search input {
  min-width: 0;
  flex: 1;
  padding: 0;
  color: var(--creation-ink);
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 600;
}

.project-search input::placeholder {
  color: #a1a69e;
}

.project-search button {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  color: var(--creation-muted);
  background: #f1f3ef;
  cursor: pointer;
}

.project-filter-tabs {
  background: var(--creation-surface-muted);
  border-top: 1px solid #ecefe9;
  border-bottom: 1px solid var(--creation-line);
  scrollbar-width: thin;
}

.project-filter-tabs button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  flex: 0 0 auto;
  padding: 0 11px;
  color: #747b72;
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition: color 160ms ease, background-color 160ms ease, border-color 160ms ease;
}

.project-filter-tabs button strong {
  display: grid;
  min-width: 20px;
  height: 20px;
  place-items: center;
  padding: 0 5px;
  color: #858c83;
  background: #ecefe9;
}

.project-filter-tabs button:hover {
  color: var(--creation-ink);
  background: #fff;
  border-color: var(--creation-line);
}

.project-filter-tabs button.is-active {
  color: var(--creation-orange-dark);
  background: #fff;
  border-color: #efb49f;
}

.project-filter-tabs button.is-active strong {
  color: #fff;
  background: var(--creation-orange);
}

.project-ledger__table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.project-ledger__table thead {
  background: #fff;
  border-bottom: 1px solid var(--creation-line);
}

.project-ledger__table th {
  height: 48px;
  padding: 0 13px;
  color: #858b83;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  letter-spacing: 0.015em;
}

.project-ledger__table th:first-child,
.project-ledger__table td:first-child {
  padding-left: 24px;
}

.project-ledger__table th:last-child,
.project-ledger__table td:last-child {
  padding-right: 24px;
}

.project-ledger__table th:nth-child(1) {
  width: 19%;
}

.project-ledger__table th:nth-child(2) {
  width: 11%;
}

.project-ledger__table th:nth-child(3) {
  width: 16%;
}

.project-ledger__table th:nth-child(4) {
  width: 18%;
}

.project-ledger__table th:nth-child(5) {
  width: 11%;
}

.project-ledger__table th:nth-child(6) {
  width: 12%;
}

.project-ledger__table th:nth-child(7) {
  width: 13%;
}

.project-ledger__table tbody tr {
  height: 126px;
  background: #fff;
  border-bottom: 1px solid #e8ebe5;
  animation: row-in 0.24s ease both;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.project-ledger__table tbody tr:hover {
  background: #fbfcf9;
  box-shadow: inset 3px 0 0 var(--creation-orange);
}

.project-ledger__table tbody tr:last-child {
  border-bottom: 0;
}

.project-ledger__table td {
  padding: 17px 13px;
  vertical-align: middle;
}

.project-cell {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
}

.project-cell__mark {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #9c583e;
  background: var(--creation-orange-soft);
  border: 1px solid #f2d2c6;
  border-radius: 10px;
  font-size: 13px;
}

.project-cell__mark.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
  border-color: #ddd6e8;
}

.project-cell__mark.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
  border-color: #cfe1da;
}

.project-cell > div > strong,
.project-cell > div > span,
.project-cell > div > p,
.target-cell small,
.state-cell strong,
.state-cell small,
.readiness-cell small,
.project-status strong,
.project-status small,
.update-cell strong,
.update-cell small {
  display: block;
}

.project-cell > div {
  min-width: 0;
}

.project-cell > div > strong {
  overflow: hidden;
  color: #2b302a;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-cell > div > span {
  margin-top: 5px;
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-cell > div > p {
  overflow: hidden;
  margin: 5px 0 0;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.target-badge {
  display: inline-flex;
  min-width: 48px;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  color: #676e66;
  background: #eef0ed;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.target-badge.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.target-badge.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.target-badge.is-both {
  color: #a44728;
  background: var(--creation-orange-soft);
}

.target-cell small {
  margin-top: 7px;
  color: var(--creation-subtle);
  font-size: 12px;
  line-height: 1.45;
}

.source-dataset-cell {
  min-width: 0;
}

.state-cell strong {
  overflow: hidden;
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.state-cell strong i {
  margin-right: 6px;
}

.state-cell.is-ready strong {
  color: var(--creation-green);
}

.state-cell.is-alert strong {
  color: #b54627;
}

.state-cell.is-waiting strong {
  color: var(--creation-muted);
}

.state-cell small {
  margin-top: 5px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.dataset-tags span {
  padding: 4px 6px;
  color: #6f756c;
  background: #f1f3ef;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
}

.readiness-cell > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.readiness-cell > div:first-child strong {
  overflow: hidden;
  color: #4c534b;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.readiness-cell > div:first-child span {
  color: var(--creation-olive);
  font-size: 12px;
  font-weight: 700;
}

.readiness-bar {
  height: 5px;
  margin-top: 9px;
  overflow: hidden;
  background: #e8ebe5;
  border-radius: 999px;
}

.readiness-bar > span {
  display: block;
  height: 100%;
  min-width: 5px;
  background: var(--creation-orange);
  border-radius: inherit;
  transition: width 220ms ease;
}

.readiness-bar > span.is-complete {
  background: var(--creation-green);
}

.readiness-bar > span.is-review {
  background: var(--creation-violet);
}

.readiness-bar > span.is-alert {
  background: #c9502e;
}

.readiness-bar > span.is-progress {
  background: var(--creation-olive);
}

.readiness-cell small {
  margin-top: 7px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-status strong {
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-status strong i {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 7px;
  border-radius: 999px;
  background: #9da39b;
}

.project-status.is-complete strong {
  color: var(--creation-green);
}

.project-status.is-complete strong i {
  background: var(--creation-green);
}

.project-status.is-alert strong {
  color: #b54627;
}

.project-status.is-alert strong i {
  background: var(--creation-orange);
}

.project-status.is-review strong {
  color: var(--creation-violet);
}

.project-status.is-review strong i {
  background: var(--creation-violet);
}

.project-status.is-progress strong {
  color: #7a6237;
}

.project-status.is-progress strong i {
  background: #bd8b35;
}

.project-status small {
  margin-top: 7px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.update-cell {
  min-width: 0;
}

.update-cell strong {
  overflow: hidden;
  color: #596058;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-action {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.row-action__primary {
  min-height: 36px;
  gap: 8px;
  padding: 0 12px;
  color: #fff;
  background: #343934;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.row-action__primary:hover {
  background: var(--creation-orange);
}

.row-action__delete {
  min-height: 36px;
  gap: 6px;
  padding: 0 10px;
  color: #a64e3d;
  background: #fff;
  border: 1px solid #e6c5bd;
  white-space: nowrap;
}

.row-action__delete:hover:not(:disabled) {
  color: #8d3d2f;
  background: #fff4f1;
  border-color: #d58b7a;
}

.row-action__delete:disabled {
  color: #aeb5b1;
  background: #f5f6f5;
  border-color: #e1e5e2;
  cursor: wait;
}

.project-empty {
  display: grid;
  min-height: 300px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: var(--creation-subtle);
  text-align: center;
}

.project-empty > span {
  display: grid;
  width: 48px;
  height: 48px;
  margin-bottom: 4px;
  place-items: center;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 12px;
  font-size: 18px;
}

.project-empty strong {
  color: #4f574e;
  font-size: 13px;
}

.project-empty p {
  margin: 0;
  font-size: 12px;
}

.project-empty button {
  min-height: 36px;
  margin-top: 7px;
  padding: 0 13px;
  color: #fff;
  background: #343934;
}

.project-ledger__footer {
  color: var(--creation-muted);
  background: var(--creation-surface-muted);
  border-top: 1px solid var(--creation-line);
}

.project-ledger__footer > strong {
  color: #596058;
  font-weight: 700;
}

.project-ledger__footer > span {
  justify-self: end;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pagination button {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line);
}

.pagination button.is-active {
  color: #fff;
  background: var(--creation-orange);
  border-color: var(--creation-orange);
}

.pagination button:disabled {
  color: #c3c8c1;
  background: #f1f3ef;
  cursor: default;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.project-modal-backdrop,
.project-created-backdrop {
  position: fixed;
  inset: 0;
  z-index: 110;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(31, 36, 31, 0.66);
  backdrop-filter: blur(7px);
}

.project-modal,
.project-created-modal {
  width: min(620px, 100%);
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 16px;
  box-shadow: 0 28px 80px rgba(20, 26, 20, 0.28);
  animation: modal-in 180ms ease both;
}

.project-modal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 26px 28px 23px;
  background: var(--creation-surface-muted);
  border-bottom: 1px solid var(--creation-line);
}

.project-modal__heading > span,
.project-created-modal__body > p:first-of-type {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.project-modal > header h2 {
  margin: 8px 0 0;
  color: var(--creation-ink);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.project-modal > header p {
  max-width: 470px;
  margin: 8px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.project-modal > header > button {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line);
  cursor: pointer;
}

.project-modal > header > button:hover {
  color: var(--creation-ink);
  border-color: var(--creation-line-strong);
}

.modal-body {
  display: grid;
  gap: 22px;
  padding: 25px 28px;
}

.field > span,
.output-choice > span {
  display: block;
  margin-bottom: 9px;
  color: #525a51;
  font-size: 12px;
  font-weight: 700;
}

.field > input {
  width: 100%;
  min-height: 46px;
  padding: 0 13px;
  color: var(--creation-ink);
  background: #fff;
  border: 1px solid var(--creation-line-strong) !important;
  border-radius: 8px;
  outline: 0;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 700;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.field > input:focus {
  border-color: #83976a !important;
  box-shadow: 0 0 0 3px rgba(102, 125, 62, 0.1) !important;
}

.field > small {
  display: block;
  margin-top: 7px;
  color: var(--creation-subtle);
  font-size: 12px;
}

.output-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.output-choice > span {
  grid-column: 1/-1;
}

.output-choice label {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 24px;
  min-height: 88px;
  align-items: center;
  gap: 11px;
  padding: 14px;
  background: var(--creation-surface-muted);
  border: 1px solid var(--creation-line);
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.output-choice label:hover {
  border-color: var(--creation-line-strong);
}

.output-choice label.is-checked {
  background: #fffaf7;
  border-color: #eca98f;
  box-shadow: 0 0 0 3px rgba(223, 89, 52, 0.07);
}

.output-choice label.is-disabled {
  color: #8d948c;
  background: #f3f4f1;
  border-color: #dfe3dd;
  cursor: not-allowed;
}

.output-choice label.is-disabled:hover {
  border-color: #dfe3dd;
}

.output-choice label.is-disabled .output-choice__icon,
.output-choice label.is-disabled .output-choice__check {
  color: #959c94;
  background: #e5e8e3;
}

.output-choice input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.output-choice__icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 10px;
  font-size: 14px;
}

.output-choice__icon.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.output-choice__icon.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.output-choice label > div {
  min-width: 0;
}

.output-choice strong,
.output-choice small {
  display: block;
}

.output-choice strong {
  color: #343a33;
  font-size: 12px;
  font-weight: 700;
}

.output-choice small {
  margin-top: 5px;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.4;
}

.output-choice small.output-choice__preparing {
  color: #7c837b;
  font-weight: 700;
}

.output-choice__check {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: #fff;
  background: #d4d9d2;
  border-radius: 6px;
  font-size: 12px;
}

.output-choice label.is-checked .output-choice__check {
  background: var(--creation-orange);
}

.contract-note {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  padding: 16px;
  color: var(--creation-muted);
  background: var(--creation-olive-soft);
  border: 1px solid #dce5d2;
  border-radius: 10px;
}

.contract-note__icon {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--creation-olive);
  background: rgba(102, 125, 62, 0.1);
  border-radius: 8px;
  font-size: 12px;
}

.contract-note__copy {
  min-width: 0;
}

.contract-note strong {
  display: block;
  color: #4c5c3d;
  font-size: 12px;
  line-height: 1.4;
}

.contract-note p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.5;
}

.contract-note__status {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 9px;
  color: #687067;
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid rgba(102, 125, 62, 0.14);
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}

.contract-note__status i {
  flex: 0 0 auto;
  color: #7d8876;
  font-size: 12px;
}

.project-modal > footer,
.project-created-modal > footer {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 28px;
  background: var(--creation-surface-muted);
  border-top: 1px solid var(--creation-line);
}

.project-modal > footer > div {
  display: flex;
  margin-left: auto;
  gap: 8px;
}

.modal-cancel,
.modal-submit,
.project-created-action {
  min-height: 42px;
  padding: 0 16px;
}

.modal-cancel {
  color: #5c645b;
  background: #fff;
  border: 1px solid var(--creation-line);
}

.modal-cancel:hover {
  background: #f1f3ef;
}

.modal-submit,
.project-created-action {
  gap: 9px;
  color: #fff;
  background: var(--creation-orange);
}

.modal-submit:hover,
.project-created-action:hover {
  background: var(--creation-orange-dark);
}

.modal-submit:disabled {
  color: #a7aca5;
  background: #e3e6e1;
  cursor: not-allowed;
}

.project-created-modal {
  max-width: 460px;
  text-align: center;
}

.project-created-modal__body {
  padding: 38px 32px 30px;
}

.project-created-modal__icon {
  display: grid;
  width: 54px;
  height: 54px;
  margin: 0 auto 17px;
  place-items: center;
  color: #fff;
  background: var(--creation-green);
  border-radius: 50%;
  box-shadow: 0 9px 22px rgba(46, 116, 93, 0.18);
  font-size: 17px;
}

.project-created-modal__body > p:first-of-type {
  justify-content: center;
  margin: 0;
}

.project-created-modal__body h2 {
  margin: 8px 0 0;
  color: var(--creation-ink);
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.project-created-modal__body > p:last-of-type {
  margin: 9px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.project-created-summary {
  margin-top: 22px;
  padding: 15px;
  text-align: left;
  background: var(--creation-surface-muted);
  border: 1px solid var(--creation-line);
  border-radius: 10px;
}

.project-created-summary > span,
.project-created-summary > strong {
  display: block;
}

.project-created-summary > span {
  color: var(--creation-subtle);
  font-size: 12px;
}

.project-created-summary > strong {
  margin-top: 5px;
  color: #343a33;
  font-size: 12px;
}

.project-created-summary > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.project-created-summary em {
  padding: 5px 8px;
  color: #a44728;
  background: var(--creation-orange-soft);
  border-radius: 5px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-created-modal > footer {
  justify-content: center;
}

@keyframes row-in {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes modal-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1280px) {
  .creation-overview {
    grid-template-columns: minmax(230px, 1.2fr) repeat(3, minmax(150px, 1fr));
  }
  .project-ledger__table th:nth-child(6),
  .project-ledger__table td:nth-child(6) {
    display: none;
  }
  .project-ledger__table th:nth-child(1) {
    width: 22%;
  }
  .project-ledger__table th:nth-child(2) {
    width: 12%;
  }
  .project-ledger__table th:nth-child(3) {
    width: 19%;
  }
  .project-ledger__table th:nth-child(4) {
    width: 22%;
  }
  .project-ledger__table th:nth-child(5) {
    width: 13%;
  }
  .project-ledger__table th:nth-child(7) {
    width: 12%;
  }
}
@media (max-width: 1040px) {
  .creation-overview {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .creation-overview__intro {
    grid-column: 1/-1;
    min-height: 104px !important;
  }
  .creation-overview > article:nth-child(2) {
    border-left: 0;
  }
  .creation-path {
    grid-template-columns: 1fr;
  }
  .creation-path__header {
    border-right: 0;
    border-bottom: 1px solid var(--creation-line);
  }
  .project-ledger__table th:nth-child(3),
  .project-ledger__table td:nth-child(3) {
    display: none;
  }
  .project-ledger__table th:nth-child(1) {
    width: 27%;
  }
  .project-ledger__table th:nth-child(2) {
    width: 14%;
  }
  .project-ledger__table th:nth-child(4) {
    width: 27%;
  }
  .project-ledger__table th:nth-child(5) {
    width: 16%;
  }
  .project-ledger__table th:nth-child(7) {
    width: 16%;
  }
}
@media (max-width: 820px) {
  .creation-header__actions {
    width: 100%;
  }
  .creation-primary {
    margin-left: auto;
  }
  .creation-overview {
    grid-template-columns: 1fr;
  }
  .creation-overview__intro {
    grid-column: auto;
  }
  .creation-overview > article + article {
    border-top: 1px solid var(--creation-line);
    border-left: 0;
  }
  .creation-metric {
    min-height: 96px !important;
  }
  .creation-path__steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .creation-path__steps li:nth-child(3) {
    border-left: 0;
  }
  .creation-path__steps li:nth-child(n+3) {
    border-top: 1px solid #ecefe9;
  }
  .project-card-list {
    background: #f1f3ef;
  }
  .project-card {
    padding: 18px;
    background: #fff;
    border: 1px solid var(--creation-line);
    border-radius: 11px;
    animation: row-in 0.24s ease both;
  }
  .project-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .project-card__identity {
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr);
    align-items: center;
    gap: 11px;
    min-width: 0;
  }
  .project-card__identity > div {
    min-width: 0;
  }
  .project-card__identity strong,
  .project-card__identity span {
    display: block;
  }
  .project-card__identity strong {
    overflow: hidden;
    color: var(--creation-ink);
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .project-card__identity span {
    margin-top: 5px;
    color: var(--creation-muted);
    font-size: 12px;
  }
  .project-card__progress {
    margin-top: 18px;
  }
  .project-card__progress > div:first-child {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    color: #50584f;
    font-size: 12px;
  }
  .project-card__progress p {
    margin: 7px 0 0;
    color: var(--creation-subtle);
    font-size: 12px;
  }
  .project-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 16px 0 0;
  }
  .project-card dl div {
    padding: 11px;
    background: var(--creation-surface-muted);
    border-radius: 8px;
  }
  .project-card dt {
    color: var(--creation-subtle);
    font-size: 12px;
    font-weight: 700;
  }
  .project-card dd {
    margin: 5px 0 0;
    color: #4f574e;
    font-size: 12px;
    font-weight: 700;
  }
  .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    margin-top: 14px;
  }
  .project-card__actions button {
    min-height: 42px;
    gap: 9px;
  }
  .project-card__open {
    width: 100%;
    color: #fff;
    background: #343934;
  }
  .project-card__delete {
    min-width: 76px;
    padding: 0 13px;
    color: #a64e3d;
    background: #fff;
    border: 1px solid #e6c5bd;
  }
  .project-card__delete:disabled {
    color: #aeb5b1;
    background: #f5f6f5;
    border-color: #e1e5e2;
    cursor: wait;
  }
}
@media (max-width: 560px) {
  .creation-shell {
    width: min(100% - 24px, 1480px);
  }
  .creation-header__actions {
    flex-wrap: wrap;
  }
  .creation-utility {
    display: none;
  }
  .creation-primary {
    width: 100%;
    margin: 0;
  }
  .creation-path__steps {
    grid-template-columns: 1fr;
  }
  .creation-path__steps li + li,
  .creation-path__steps li:nth-child(3) {
    border-top: 1px solid #ecefe9;
    border-left: 0;
  }
  .project-ledger__footer .pagination {
    display: none;
  }
  .project-card header {
    align-items: flex-start;
  }
  .project-card dl {
    grid-template-columns: 1fr;
  }
  .output-choice {
    grid-template-columns: 1fr;
  }
  .project-modal-backdrop,
  .project-created-backdrop {
    align-items: end;
    padding: 10px;
  }
  .project-modal,
  .project-created-modal {
    max-height: calc(100vh - 20px);
    overflow-y: auto;
    border-radius: 14px;
  }
  .project-modal > header,
  .project-created-modal__body,
  .modal-body {
    padding-inline: 20px;
  }
  .project-modal > footer,
  .project-created-modal > footer {
    padding-inline: 20px;
  }
  .project-modal > footer > div {
    width: 100%;
  }
  .project-modal > footer button {
    flex: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .project-ledger__table tbody tr,
  .project-card,
  .project-modal,
  .project-created-modal {
    animation: none;
  }
  .creation-utility,
  .creation-primary,
  .project-filter-tabs button,
  .row-action button,
  .readiness-bar > span {
    transition: none;
  }
}
/* Unified operations header ------------------------------------------------ */
.creation-header .creation-header__inner {
  box-sizing: border-box;
}

.creation-heading {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.creation-eyebrow {
  width: fit-content;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
  line-height: 1.2;
}

.creation-heading .reviewops-page-title {
  margin: 0;
}

.creation-heading > p:last-child {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.creation-header__actions {
  align-self: center;
  margin-left: auto;
}

.creation-primary {
  min-height: 42px;
  margin-left: 0;
  padding: 0 19px;
}

@media (max-width: 920px) {
  .creation-header__actions {
    width: 100%;
    align-self: stretch;
    margin-left: 0;
  }
  .creation-primary {
    width: 100%;
  }
}
/* Brighter project workspace surfaces ------------------------------------- */
.creation-page {
  --creation-surface: #ffffff;
  --creation-surface-muted: #fbfcfa;
}

.creation-page .creation-overview,
.creation-page .creation-path,
.creation-page .project-ledger,
.creation-page .project-card,
.creation-page .creation-path__header,
.creation-page .project-ledger__header,
.creation-page .project-filter-tabs {
  background: #ffffff !important;
}

.creation-page .creation-overview,
.creation-page .creation-path,
.creation-page .project-ledger,
.creation-page .project-card {
  border-color: #e3e7e1 !important;
}

.creation-page .creation-overview__intro {
  color: var(--creation-ink);
  background: #fff7f2 !important;
  box-shadow: inset 4px 0 0 var(--creation-orange);
}

.creation-page .creation-overview__intro > span {
  color: var(--creation-orange);
}

.creation-page .creation-overview__intro strong {
  color: var(--creation-ink);
}

.creation-page .creation-overview__intro p {
  color: var(--creation-muted);
}

/* Keep the primary list action beside search instead of in the page header. */
:host-context(.reviewops-shell) .creation-page .project-ledger__controls .project-search {
  justify-self: end;
}

:host-context(.reviewops-shell) .creation-page .creation-primary--ledger {
  width: auto !important;
  min-height: 42px;
  margin: 0 !important;
  padding-inline: 16px;
  white-space: nowrap;
}

@media (max-width: 920px) {
  :host-context(.reviewops-shell) .creation-page .creation-primary--ledger {
    width: 100% !important;
  }
}
/* The footer owns the final divider; avoid a second line from the last row. */
:host-context(.reviewops-shell) .creation-page .project-ledger__table tbody > tr:last-child > td {
  border-bottom: 0 !important;
}

/* QA list only: entity pages import this file, so every added rule requires this root. */
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table th {
  width: auto;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table th,
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table td {
  display: table-cell;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__column--metadata {
  width: 180px;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__column--actions {
  width: 164px;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  margin-top: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell small {
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .source-dataset-cell {
  margin-top: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .project-status {
  margin-top: 16px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata {
  display: grid;
  gap: 12px;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dt {
  color: var(--creation-muted);
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd {
  margin: 4px 0 0;
  color: var(--creation-ink);
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .row-action {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
  justify-items: stretch;
  gap: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > strong,
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > span,
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > p,
:host-context(.reviewops-shell) .qa-project-list .state-cell strong,
:host-context(.reviewops-shell) .qa-project-list .state-cell small,
:host-context(.reviewops-shell) .qa-project-list .readiness-cell > div:first-child strong,
:host-context(.reviewops-shell) .qa-project-list .readiness-cell small,
:host-context(.reviewops-shell) .qa-project-list .project-status small,
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd,
:host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
:host-context(.reviewops-shell) .qa-project-list .project-card__identity span,
:host-context(.reviewops-shell) .qa-project-list .project-card dd {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
  word-break: normal;
  overflow-wrap: anywhere;
}
:host-context(.reviewops-shell) .qa-project-list .readiness-cell > div:first-child {
  flex-wrap: wrap;
}
:host-context(.reviewops-shell) .qa-project-list .row-action > a,
:host-context(.reviewops-shell) .qa-project-list .row-action > button,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions > a,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions > button {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding-inline: 12px;
  white-space: nowrap;
  overflow-wrap: normal;
}
:host-context(.reviewops-shell) .qa-project-list .row-action i,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions i {
  flex: 0 0 auto;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .qa-project-list .project-card-list {
    background: #f1f3ef;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card {
    padding: 18px;
    background: #fff;
    border: 1px solid var(--creation-line);
    border-radius: 11px;
    animation: row-in 0.24s ease both;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity {
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr);
    align-items: center;
    gap: 11px;
    min-width: 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity > div {
    min-width: 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span {
    display: block;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong {
    overflow: hidden;
    color: var(--creation-ink);
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span {
    margin-top: 5px;
    color: var(--creation-muted);
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress {
    margin-top: 18px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress > div:first-child {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    color: #50584f;
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress p {
    margin: 7px 0 0;
    color: var(--creation-subtle);
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 16px 0 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dl div {
    padding: 11px;
    background: var(--creation-surface-muted);
    border-radius: 8px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dt {
    color: var(--creation-subtle);
    font-size: 12px;
    font-weight: 700;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dd {
    margin: 5px 0 0;
    color: #4f574e;
    font-size: 12px;
    font-weight: 700;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    margin-top: 14px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions button {
    min-height: 42px;
    gap: 9px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__open {
    width: 100%;
    color: #fff;
    background: #343934;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__delete {
    min-width: 76px;
    padding: 0 13px;
    color: #a64e3d;
    background: #fff;
    border: 1px solid #e6c5bd;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__delete:disabled {
    color: #aeb5b1;
    background: #f5f6f5;
    border-color: #e1e5e2;
    cursor: wait;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span,
  :host-context(.reviewops-shell) .qa-project-list .project-card dd {
    overflow: visible;
    white-space: normal;
    text-overflow: clip;
    overflow-wrap: anywhere;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 92px;
    gap: 8px;
  }
}
@media (max-width: 560px) {
  :host-context(.reviewops-shell) .qa-project-list .project-card dl {
    grid-template-columns: 1fr;
  }
}

/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .qa-project-list .project-ledger__title p {
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .qa-list-filters {
  border-bottom: 1px solid var(--ro-line);
}
:host-context(.reviewops-shell) .qa-project-list .qa-list-filters > summary {
  min-height: 44px;
  padding: 10px 16px;
  cursor: pointer;
  color: var(--ro-ink);
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .qa-project-details {
  margin-top: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .qa-project-details > summary {
  cursor: pointer;
  min-height: 44px;
  padding-block: 10px;
  color: var(--ro-accent);
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell__mark {
  position: static;
  display: grid;
  place-items: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell__mark > i {
  position: static;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div {
  min-width: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > strong, :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong {
  word-break: keep-all;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell, :host-context(.reviewops-shell) .qa-project-list .source-dataset-cell, :host-context(.reviewops-shell) .qa-project-list .project-status {
  margin-top: 4px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata {
  gap: 4px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata > div {
  display: flex;
  flex-wrap: wrap;
  gap: 0 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd {
  margin-top: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state {
  display: grid;
  gap: 4px;
  margin: 12px 0;
  font-size: 14px;
  line-height: 22px;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state strong {
  color: var(--ro-ink);
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state span {
  color: var(--ro-muted);
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity > .project-cell__mark {
  grid-column: 1;
  grid-row: 1;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity > div {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card dl {
  margin-top: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-card dl > div {
  padding: 8px 0;
  background: transparent;
  border-bottom: 1px solid var(--ro-line);
  border-radius: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__actions {
  margin-top: 8px;
}
@media (max-width: 639px) {
  :host-context(.reviewops-shell) .qa-project-list .qa-list-filters > summary {
    padding-inline: 16px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card {
    padding: 16px;
    border-radius: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header > .target-badge {
    justify-self: start;
  }
}`],
})
export class PageReviewProjectsComponent implements OnInit {
    public keyword: string = '';
    public filter: string = 'all';
    public currentPage: number = 1;
    public readonly pageSize: number = 10;
    public showCreateModal: boolean = false;
    public showCreatedModal: boolean = false;
    public createData: any = {};
    public createdProject: any = null;
    public uiLoading: boolean = true;
    public loadError: string = '';
    private nextProjectNumber: number = 16;
    private readonly workspaceStateUrl: string = '/api/v1/review-workspace/state';
    private readonly workspaceManagementUrl: string = '/api/v1/review-workspace/management';
    private workspaceServerMode: boolean = false;

    public workflow: any[] = [
        { no: 1, icon: 'fa-folder-plus', short: 'QA 프로젝트', label: '목적에 맞는 프로젝트를 만듭니다.' },
        { no: 2, icon: 'fa-wand-magic-sparkles', short: '기준 만들기', label: 'AI 또는 파일로 하네스·설문지를 준비합니다.' },
        { no: 3, icon: 'fa-list-check', short: 'QA 생성·검수', label: '자료와 기준을 선택해 QA를 만들고 검수합니다.' },
        { no: 4, icon: 'fa-arrows-rotate', short: '자동 개선', label: '목표 점수까지 피드백을 반영해 버전을 발전시킵니다.' }
    ];

    public filters: any[] = [
        { code: 'all', label: '전체 상태' },
        { code: 'action', label: '설정 필요' },
        { code: 'human', label: '검수 준비' },
        { code: 'improve', label: '보완 필요' },
        { code: 'blocked', label: '연결 필요' },
        { code: 'complete', label: '생성 완료' }
    ];

    public projects: any[] = [];
    public deletingProjectId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        await this.loadWorkspaceProjects();
        this.resetCreateData();
        this.showCreateModal = this.createModalRequested();
        await this.service.render();
    }

    private createModalRequested() {
        if (typeof window === 'undefined') return false;
        const params = new URLSearchParams(window.location.search || '');
        return params.get('create') === '1';
    }

    private async fetchWorkspaceState() {
        const response = await fetch(this.workspaceStateUrl, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('REVIEW_WORKSPACE_STATE_UNAVAILABLE');
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            throw new Error('REVIEW_WORKSPACE_STATE_INVALID');
        }
        const state = this.workspaceState(payload);
        if (!state) throw new Error('REVIEW_WORKSPACE_STATE_INVALID');
        return state;
    }

    private workspaceState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;

        const projects = Array.isArray(state.projects)
            ? state.projects
            : (state.projects && typeof state.projects === 'object' ? Object.values(state.projects) : []);
        const tasks = Array.isArray(state.tasks)
            ? state.tasks
            : (state.tasks && typeof state.tasks === 'object' ? Object.values(state.tasks) : []);
        const evaluations = state.evaluations && typeof state.evaluations === 'object'
            ? state.evaluations
            : {};
        return Object.assign({}, state, { projects, tasks, evaluations });
    }

    private workspaceMutation(payload: any) {
        const candidates = [
            payload?.data?.data,
            payload?.data,
            payload?.result,
            payload
        ];
        const result = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && candidate.state && typeof candidate.state === 'object');
        if (!result) return null;
        const state = this.workspaceState({ state: result.state });
        return state ? Object.assign({}, result, { state }) : null;
    }

    private workspaceLoadMessage(error: any) {
        const code = error instanceof Error ? error.message : '';
        if (code === 'REVIEW_WORKSPACE_STATE_UNAVAILABLE') {
            return '프로젝트 목록 서버에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.';
        }
        if (code === 'REVIEW_WORKSPACE_STATE_INVALID') {
            return '프로젝트 목록 응답을 확인할 수 없습니다. 다시 불러와주세요.';
        }
        return code || '프로젝트 목록을 불러오지 못했습니다.';
    }

    private async mutateWorkspace(request: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(request));
        const response = await fetch(this.workspaceManagementUrl, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            body
        });
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }
        if (!response.ok) throw new Error(payload?.message || '프로젝트를 서버에 저장하지 못했습니다.');
        const result = this.workspaceMutation(payload);
        if (!result) throw new Error('프로젝트 저장 응답이 올바르지 않습니다.');
        return result;
    }

    private taskKind(task: any) {
        return String(task?.kind || task?.type || task?.outputType || task?.output_type || '').toLowerCase();
    }

    private projectTasks(state: any, projectId: string) {
        const tasks = Array.isArray(state?.tasks) ? state.tasks : [];
        return tasks.filter((task: any) => {
            const id = task?.projectId || task?.project_id || task?.project?.id;
            return String(id || '') === String(projectId || '');
        });
    }

    private projectEvaluations(state: any, projectId: string) {
        const evaluations = Array.isArray(state?.evaluations)
            ? state.evaluations
            : (state?.evaluations && typeof state.evaluations === 'object' ? Object.values(state.evaluations) : []);
        return evaluations.filter((evaluation: any) => {
            const task = this.projectTasks(state, projectId).find((item: any) => {
                const taskId = evaluation?.taskId || evaluation?.task_id;
                return String(item?.id || '') === String(taskId || '');
            });
            const id = evaluation?.projectId || evaluation?.project_id || evaluation?.project?.id
                || task?.projectId || task?.project_id;
            return String(id || '') === String(projectId || '');
        });
    }

    private numericValue(...values: any[]) {
        for (const value of values) {
            if (value === null || value === undefined || value === '') continue;
            const numeric = Number(value);
            if (Number.isFinite(numeric)) return numeric;
        }
        return null;
    }

    activeFilterLabel() { return this.filters.find(item => item.code === this.filter)?.label || '전체'; }

    private dateTimeLabel(value: any) {
        return workspaceDateTime(value);
    }

    private normalizeServerProject(row: any, state: any) {
        const metadata = row?.metadata && typeof row.metadata === 'object' ? row.metadata : {};
        const settings = row?.settings && typeof row.settings === 'object' ? row.settings : {};
        const tasks = this.projectTasks(state, row?.id);
        const evaluations = this.projectEvaluations(state, row?.id);
        const qaTasks = tasks.filter((task: any) => this.taskKind(task).indexOf('qa') >= 0);
        const kgTasks = tasks.filter((task: any) => this.taskKind(task).indexOf('kg') >= 0);
        const qaEnabled = row?.outputs?.qa !== undefined
            ? !!row.outputs.qa
            : !!(settings.qa || row?.qaCount || row?.qa_count || qaTasks.length);
        const kgEnabled = row?.outputs?.kg !== undefined
            ? !!row.outputs.kg
            : !!(settings.kg || row?.kgCount || row?.kg_count || kgTasks.length);
        const qaCount = this.numericValue(row?.qaCount, row?.qa_count, row?.qa, metadata?.qaCount, metadata?.qa_count) || 0;
        const kgCount = this.numericValue(row?.kgCount, row?.kg_count, row?.kg, row?.tripleCount, row?.triple_count, metadata?.kgCount) || 0;
        const scores = evaluations
            .map((evaluation: any) => this.numericValue(evaluation?.score, evaluation?.totalScore, evaluation?.total_score))
            .filter((score: any) => score !== null) as number[];
        const combinedScore = this.numericValue(
            row?.combinedScore, row?.combined_score, row?.score,
            scores.length ? scores.reduce((sum: number, score: number) => sum + score, 0) / scores.length : null
        );
        const completedTasks = tasks.filter((task: any) => {
            const status = String(task?.status || '').toLowerCase();
            return ['completed', 'complete', 'approved', 'passed', 'done'].indexOf(status) >= 0;
        }).length;
        const target = this.numericValue(row?.target, row?.targetScore, row?.target_score, settings?.qa?.target, settings?.kg?.target) || 90;
        const isComplete = row?.bucket === 'complete'
            || row?.status === '생성 완료'
            || row?.status === 'completed'
            || (qaEnabled || kgEnabled) && qaCount + kgCount > 0
                && (tasks.length === 0 || evaluations.length >= tasks.length || completedTasks === tasks.length);
        const configured = row?.configured !== undefined
            ? !!row.configured
            : !!(settings.qa || settings.kg || row?.source || row?.sourceLabel || row?.source_label);
        const sourceIds = Array.isArray(row?.source_ids)
            ? row.source_ids
            : (Array.isArray(row?.sourceIds) ? row.sourceIds : []);
        const sourceTitles = Array.isArray(row?.source_titles)
            ? row.source_titles
            : (Array.isArray(row?.sourceTitles) ? row.sourceTitles : []);
        const reviewCounts = row?.review_counts || row?.reviewCounts || {};
        const sourceCount = this.numericValue(
            row?.sourceDocumentCount, row?.source_document_count, row?.sourceCount, metadata?.sourceCount,
            sourceIds.length || null
        );
        const declaredReviewTotal = this.numericValue(reviewCounts?.qa, reviewCounts?.kg) === null
            ? null
            : (Number(reviewCounts?.qa || 0) + Number(reviewCounts?.kg || 0));

        return {
            ...row,
            id: String(row?.id || ''),
            name: row?.name || row?.title || '이름 없는 프로젝트',
            domain: row?.domain || row?.topic || '독도',
            lifecycle: row?.lifecycle || (isComplete ? '운영 중' : (configured ? '설정 중' : '설정 전')),
            bucket: row?.bucket || (isComplete ? 'complete' : (configured ? 'human' : 'action')),
            isContainer: true,
            configured,
            round: this.numericValue(row?.round, row?.currentRound, row?.current_round) || 1,
            stageNo: this.numericValue(row?.stageNo, row?.stage_no) || (isComplete ? 4 : (configured ? 3 : 1)),
            stage: row?.stage || (isComplete ? 'QA·KG 생성 및 검수' : (configured ? '검수 진행' : '프로젝트 설정')),
            stageState: row?.stageState || row?.stage_state || (isComplete ? '결과 확인 가능' : '설정·실행 진행 중'),
            stageProgress: this.numericValue(row?.stageProgress, row?.stage_progress, row?.progress) || (isComplete ? 100 : (configured ? 70 : 0)),
            sourceState: row?.sourceState || row?.source_state || (sourceCount ? '스냅샷 고정' : (configured ? '연결 완료' : '설정 필요')),
            sourceLabel: row?.sourceLabel || row?.source_label || row?.source?.label || row?.source?.provider
                || (sourceTitles.length ? sourceTitles.slice(0, 2).join(' · ') : '자료함 API'),
            snapshot: row?.snapshot || row?.snapshotId || row?.snapshot_id || metadata?.snapshot || '—',
            sourceCount: typeof row?.sourceCount === 'string'
                ? row.sourceCount
                : (sourceCount === null ? '자료 범위 미설정' : `문서 ${sourceCount.toLocaleString()}건`),
            outputs: { qa: qaEnabled, kg: kgEnabled },
            settings,
            qa: qaCount,
            kg: kgCount,
            nodes: this.numericValue(row?.nodes, row?.nodeCount, row?.node_count, metadata?.nodeCount) || 0,
            edges: this.numericValue(row?.edges, row?.edgeCount, row?.edge_count, metadata?.edgeCount) || 0,
            llmScore: this.numericValue(row?.llmScore, row?.llm_score),
            humanScore: this.numericValue(row?.humanScore, row?.human_score, combinedScore),
            combinedScore,
            responseDone: this.numericValue(row?.responseDone, row?.response_done, Math.max(evaluations.length, completedTasks)) || 0,
            responseTotal: this.numericValue(row?.responseTotal, row?.response_total, declaredReviewTotal, tasks.length) || 0,
            target,
            gap: combinedScore === null ? null : combinedScore - target,
            gate: row?.gate || (combinedScore !== null && combinedScore >= target ? '통과' : '검수 중'),
            harness: row?.harness || settings?.qa?.harness || settings?.kg?.harness || '미설정',
            harnessVersion: row?.harnessVersion || row?.harness_version || '',
            survey: row?.survey || settings?.qa?.survey || settings?.kg?.survey || '미설정',
            surveyVersion: row?.surveyVersion || row?.survey_version || '',
            owner: row?.owner || row?.reviewer || metadata?.owner || '미지정',
            nextAction: row?.nextAction || row?.next_action || (isComplete ? '결과 보기' : '프로젝트 설정 확인'),
            updatedRelative: row?.updatedRelative || row?.updated_relative || '최근 업데이트',
            createdAt: row?.createdAt || row?.created_at || row?.created || '—',
            updatedAt: this.dateTimeLabel(row?.updatedAt || row?.updated_at || row?.updated)
        };
    }

    private updateNextProjectNumber(rows: any[]) {
        const maxNumber = rows.reduce((max: number, project: any) => {
            const match = String(project?.id || '').match(/(\d+)$/);
            return match ? Math.max(max, Number(match[1])) : max;
        }, 15);
        this.nextProjectNumber = Math.max(this.nextProjectNumber, maxNumber + 1);
    }

    private async loadWorkspaceProjects() {
        this.uiLoading = true;
        await this.service.render();
        try {
            const state = await this.fetchWorkspaceState();
            this.projects = state.projects.map((project: any) => this.normalizeServerProject(project, state));
            this.updateNextProjectNumber(this.projects);
            this.workspaceServerMode = true;
            this.loadError = '';
            return true;
        } catch (error) {
            this.projects = [];
            this.workspaceServerMode = false;
            this.loadError = this.workspaceLoadMessage(error);
            return false;
        } finally {
            this.uiLoading = false;
        }
    }

    public async reloadWorkspaceProjects() {
        await this.loadWorkspaceProjects();
        await this.service.render();
    }

    public async deleteProject(project: any) {
        const projectId = String(project && project.id || '').trim();
        const projectName = String(project && project.name || projectId).trim();
        if (!projectId || this.deletingProjectId) return;

        const confirmed = await this.service.modal.show({
            title: '프로젝트 삭제',
            message: `'${projectName}' 프로젝트를 삭제하시겠습니까? 프로젝트 설정과 연결된 검수 작업은 제거됩니다. 생성 원문·결과 스냅샷 파일은 보존됩니다.`,
            cancel: '취소',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        this.deletingProjectId = projectId;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'projects', action: 'delete', id: projectId
            });
            this.projects = result.state.projects.map((row: any) => this.normalizeServerProject(row, result.state));
            this.updateNextProjectNumber(this.projects);
            await this.service.modal.success(`'${projectName}' 프로젝트를 삭제했습니다.`);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '프로젝트를 삭제하지 못했습니다.',
                false,
                '확인'
            );
        } finally {
            this.deletingProjectId = '';
            await this.service.render();
        }
    }

    private emptyOutputSetting() {
        return {
            source: '',
            harness: '',
            survey: '',
            target: 90,
            targetQaCount: 15
        };
    }

    public projectRoute(project: any) {
        if (project && project.bucket === 'complete') {
            if (project.outputs && project.outputs.qa) return '/review-projects/' + project.id + '/qa-result';
            if (project.outputs && project.outputs.kg) return '/review-projects/' + project.id + '/kg-result';
        }
        return '/review-projects/' + project.id + (project.isContainer ? '/settings' : '/dataset');
    }

    public filteredProjects() {
        const query = this.keyword.trim().toLowerCase();
        return this.projects.filter((project: any) => {
            const filterMatch = this.filter === 'all' || project.bucket === this.filter;
            const text = [project.id, project.name, project.domain, project.owner, project.stage].join(' ').toLowerCase();
            return filterMatch && (!query || text.indexOf(query) >= 0);
        });
    }

    public totalPages() {
        return Math.max(1, Math.ceil(this.filteredProjects().length / this.pageSize));
    }

    public pageNumbers() {
        return Array.from({ length: this.totalPages() }, (_: any, index: number) => index + 1);
    }

    public pagedProjects() {
        const safePage = Math.min(Math.max(this.currentPage, 1), this.totalPages());
        if (safePage !== this.currentPage) this.currentPage = safePage;
        const start = (safePage - 1) * this.pageSize;
        return this.filteredProjects().slice(start, start + this.pageSize);
    }

    public resetPage() {
        this.currentPage = 1;
    }

    public async goToPage(page: number) {
        this.currentPage = Math.min(Math.max(page, 1), this.totalPages());
        await this.service.render();
    }

    public filterCount(code: string) {
        if (code === 'all') return this.projects.length;
        return this.projects.filter((project: any) => project.bucket === code).length;
    }

    public activeCount() {
        return this.projects.filter((project: any) => project.lifecycle === '운영 중').length;
    }

    public humanQueueCount() {
        return this.projects
            .filter((project: any) => project.responseTotal > project.responseDone)
            .reduce((sum: number, project: any) => sum + (project.responseTotal - project.responseDone), 0);
    }

    public improveCount() {
        return this.projects.filter((project: any) => project.bucket === 'improve').length;
    }

    public passedCount() {
        return this.projects.filter((project: any) => project.bucket === 'complete').length;
    }

    public settingRequiredCount() {
        return this.projects.filter((project: any) => {
            return ['action', 'blocked', 'improve'].indexOf(project.bucket) >= 0;
        }).length;
    }

    public reviewReadyCount() {
        return this.projects.filter((project: any) => project.bucket === 'human').length;
    }

    public projectProgress(project: any) {
        if (project && project.bucket === 'complete') return 100;
        const value = Number(project && project.stageProgress);
        if (Number.isFinite(value) && value > 0) return Math.max(8, Math.min(96, Math.round(value)));
        if (project && (project.sourceState === '스냅샷 고정' || project.sourceState === '연결 완료')) return 28;
        return 8;
    }

    public targetType(project: any) {
        const qa = !!(project.outputs && project.outputs.qa);
        const kg = !!(project.outputs && project.outputs.kg);
        if (qa && kg) return 'QA + KG';
        if (qa) return 'QA';
        if (kg) return 'KG';
        return '미선택';
    }

    public targetHint(project: any) {
        const type = this.targetType(project);
        if (type === 'QA + KG') return '질의응답 · 지식그래프';
        if (type === 'QA') return '질의응답 데이터셋';
        if (type === 'KG') return '지식그래프 데이터셋';
        return '목표 유형 설정 필요';
    }

    public targetClass(project: any) {
        const type = this.targetType(project);
        if (type === 'QA') return 'is-qa';
        if (type === 'KG') return 'is-kg';
        if (type === 'QA + KG') return 'is-both';
        return 'is-empty';
    }

    public sourceConnection(project: any) {
        if (project.sourceState === '스냅샷 고정' || project.sourceState === '연결 완료') {
            return project.sourceCount || '원문 연결 완료';
        }
        if (project.sourceState === '재연결 필요') return '원문 재연결 필요';
        return '원문 연결 대기';
    }

    public sourceStatusClass(project: any) {
        if (project.sourceState === '스냅샷 고정' || project.sourceState === '연결 완료') return 'is-ready';
        if (project.sourceState === '재연결 필요') return 'is-alert';
        return 'is-waiting';
    }

    public datasetTotal(project: any) {
        const qa = typeof project.qa === 'number' ? project.qa : 0;
        const kg = typeof project.kg === 'number' ? project.kg : 0;
        const total = qa + kg;
        return total ? total.toLocaleString() : '—';
    }

    public datasetLabel(project: any) {
        const type = this.targetType(project);
        if (type === 'QA + KG') return 'QA·KG 데이터셋';
        if (type === 'QA') return 'QA 문항';
        if (type === 'KG') return 'KG 트리플';
        return '생성 대기';
    }

    public reviewSetting(project: any) {
        const harnessReady = project.harness && project.harness !== '미설정';
        const surveyReady = project.survey && project.survey !== '미설정';
        if (harnessReady && surveyReady) return '검수 설정 완료';
        if (harnessReady || surveyReady) return '부분 설정';
        return '미설정';
    }

    public projectStatus(project: any) {
        if (project.bucket === 'complete') return '생성 완료';
        if (project.bucket === 'blocked') return '연결 필요';
        if (project.bucket === 'improve') return '보완 필요';
        if (project.bucket === 'human') return '검수 준비';
        if (project.stageProgress > 0) return '설정 진행 중';
        return '준비 중';
    }

    public projectStatusClass(project: any) {
        if (project.bucket === 'complete') return 'is-complete';
        if (project.bucket === 'blocked') return 'is-alert';
        if (project.bucket === 'human') return 'is-review';
        return project.stageProgress > 0 ? 'is-progress' : 'is-waiting';
    }

    public projectActionLabel(project: any) {
        if (project.bucket === 'complete') return '결과 보기';
        if (project.stageProgress > 0 || project.isContainer) return '이어서 설정';
        return '설정 시작';
    }

    public async setFilter(code: string) {
        this.filter = code;
        this.resetPage();
        await this.service.render();
    }

    public async clearSearch(searchInput?: HTMLInputElement) {
        if (searchInput?.isConnected && !searchInput.disabled) searchInput.focus({preventScroll: true});
        this.keyword = '';
        this.resetPage();
        await this.service.render();
    }

    public score(value: any) {
        return value === null || value === undefined ? '미실행' : Number(value).toFixed(1);
    }

    public gapText(project: any) {
        if (project.gap === null || project.gap === undefined) return '판정 전';
        return (project.gap > 0 ? '+' : '') + Number(project.gap).toFixed(1);
    }

    public responseRate(project: any) {
        if (!project.responseTotal) return 0;
        return Math.round(project.responseDone / project.responseTotal * 100);
    }

    public stageClass(project: any) {
        if (project.bucket === 'complete') return 'is-complete';
        if (project.bucket === 'improve') return 'is-improve';
        if (project.bucket === 'blocked') return 'is-blocked';
        if (project.bucket === 'human') return 'is-human';
        return 'is-active';
    }

    public sourceClass(project: any) {
        if (project.sourceState === '재연결 필요') return 'is-error';
        if (project.sourceState === '설정 필요') return 'is-pending';
        if (project.sourceState === '스냅샷 고정') return 'is-fixed';
        return 'is-connected';
    }

    public gapClass(project: any) {
        if (project.gap === null || project.gap === undefined) return 'is-empty';
        return project.gap >= 0 ? 'is-positive' : 'is-negative';
    }

    public outputText(value: any) {
        return value === null || value === undefined ? '—' : Number(value).toLocaleString();
    }

    public projectOutputText(project: any, key: 'qa' | 'kg') {
        if (project.outputs && project.outputs[key] === false) return '미선택';
        return this.outputText(project[key]);
    }

    public targetText(value: any) {
        return value === null || value === undefined ? '미설정' : Number(value).toLocaleString() + '점';
    }

    private resetCreateData() {
        this.createData = {
            name: '', makeQa: true, makeKg: false
        };
    }

    public async openCreate() {
        this.resetCreateData();
        this.createdProject = null;
        this.showCreatedModal = false;
        this.showCreateModal = true;
        await this.service.render();
    }

    public async closeCreate() {
        this.showCreateModal = false;
        await this.service.render();
    }

    public async setCreateOutput(key: 'makeQa' | 'makeKg', event: any) {
        if (!this.createData) return;
        if (key === 'makeKg') {
            this.createData.makeKg = false;
            return;
        }
        this.createData[key] = !!(event && event.target && event.target.checked);
        await this.service.render();
    }

    public async submitCreateOnEnter(event: any) {
        if (!this.showCreateModal || !event || event.isComposing || event.repeat) return;
        const target = event.target as HTMLElement;
        if (target && (target.tagName === 'BUTTON' || target.tagName === 'A')) return;
        event.preventDefault();
        await this.createProject();
    }

    public async goToCreatedProject() {
        if (!this.showCreatedModal || !this.createdProject || !this.createdProject.id) return;
        const projectId = this.createdProject.id;
        this.showCreatedModal = false;
        await this.service.render();
        this.service.href('/review-projects/' + projectId + '/settings');
    }

    public async createProject() {
        const name = String(this.createData.name || '').trim();
        if (!name) {
            await this.service.modal.warning('프로젝트 이름을 입력해주세요.', false, '확인');
            return;
        }
        this.createData.makeQa = true;
        this.createData.makeKg = false;

        const now = new Date();
        const updatedAt = [
            now.getFullYear(),
            String(now.getMonth() + 1).padStart(2, '0'),
            String(now.getDate()).padStart(2, '0')
        ].join('.');
        const owner = this.service.auth.session && this.service.auth.session.name
            ? this.service.auth.session.name
            : '미지정';
        const id = 'RV-2026-' + String(this.nextProjectNumber).padStart(3, '0');
        const outputs = {
            qa: !!this.createData.makeQa,
            kg: false
        };
        const project = {
            id: id,
            name: name,
            domain: 'QA 프로젝트',
            lifecycle: '설정 전',
            bucket: 'action',
            isContainer: true,
            configured: false,
            stageNo: 0,
            stage: '프로젝트 설정',
            stageState: '세부 설정 필요',
            stageProgress: 0,
            sourceState: '설정 필요',
            sourceLabel: '자료 소스 미설정',
            snapshot: '미생성',
            sourceCount: '자료 범위 미설정',
            outputs: outputs,
            settings: {
                qa: outputs.qa ? this.emptyOutputSetting() : null,
                kg: outputs.kg ? this.emptyOutputSetting() : null
            },
            qa: null,
            kg: null,
            nodes: null,
            edges: null,
            llmScore: null,
            humanScore: null,
            combinedScore: null,
            responseDone: 0,
            responseTotal: 0,
            target: null,
            gap: null,
            gate: '설정 전',
            harness: '미설정',
            survey: '미설정',
            owner: owner,
            nextAction: '프로젝트 설정 시작',
            updatedRelative: '방금 전',
            updatedAt: updatedAt
        };

        if (!this.workspaceServerMode) {
            await this.service.modal.warning(
                '프로젝트 저장소에 연결되지 않아 프로젝트를 만들 수 없습니다.', false, '확인'
            );
            return;
        }
        let persistedProject = project;
        const serverItem = { ...project };
        delete serverItem.id;
        try {
            const result = await this.mutateWorkspace({ resource: 'projects', action: 'create', item: serverItem });
            this.projects = result.state.projects.map((row: any) => this.normalizeServerProject(row, result.state));
            persistedProject = this.normalizeServerProject(result.item, result.state);
            this.updateNextProjectNumber(this.projects);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '프로젝트를 서버에 저장하지 못했습니다.',
                false,
                '확인'
            );
            return;
        }
        this.showCreateModal = false;
        this.createdProject = persistedProject;
        this.showCreatedModal = true;
        await this.service.render();
    }
}

export default PageReviewProjectsComponent;